import { render, staticRenderFns } from "./edit-claim.vue?vue&type=template&id=569059fe&scoped=true&"
import script from "./edit-claim.vue?vue&type=script&lang=js&"
export * from "./edit-claim.vue?vue&type=script&lang=js&"
import style0 from "./edit-claim.vue?vue&type=style&index=0&id=569059fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569059fe",
  null
  
)

export default component.exports